import { Badge, Button } from '@mui/material';
import { alpha } from '@mui/material/styles';
import React from 'react';

const FilterButton = (props) => {
  const { children, active, onClick, endIcon, badgeContent, ...rest } = props;

  return (
    <Button
      variant='contained'
      endIcon={
        <>
          {endIcon}
          {!!badgeContent && (
            <Badge
              color='primary'
              badgeContent={badgeContent}
              sx={() => ({
                padding: 0,
                transform: 'none',
                '.BaseBadge-badge': {
                  position: 'relative',
                  fontSize: '10px',
                  minWidth: '16px',
                  height: '16px',
                  padding: 0,
                  transform: 'none',
                },
                ' .MuiBadge-badge': {
                  height: '14px',
                  minWidth: '14px',
                  fontSize: '12px',
                  padding: '0',
                },
              })}
            />
          )}
        </>
      }
      onClick={onClick}
      disableElevation
      sx={(theme) => ({
        position: 'relative',
        minWidth: 'auto',
        color: theme.palette.text.secondary,
        padding: '6px 6px',
        height: '100%',
        bgcolor: 'background.default',
        borderWidth: '0',
        borderStyle: 'solid',
        borderColor: theme.palette.divider,
        span: {
          margin: theme.spacing(0),
        },
        path: {
          fill: theme.palette.text.secondary,
        },
        '&:hover, &.active': {
          bgcolor: 'background.default',
        },
        '&.Mui-disabled': {
          bgcolor: alpha(theme.palette.text.secondary, 0.05),
        },
        ...(active && {
          color: theme.palette.primary.main + '!important',
          bgcolor: alpha(theme.palette.primary.main, 0.12) + '!important',
          borderColor: alpha(theme.palette.primary.main, 0.12),
          path: {
            fill: theme.palette.primary.main,
          },
        }),
      })}
      {...rest}>
      {/* <Typography variant="body1">{label}</Typography> */}
      {children}
    </Button>
  );
};

export default FilterButton;
